export default "__VITE_ASSET__Ckal2i67__"